export default class QuoteItemPresentAsModel {
  constructor(itemType, description, percent) {
    this.itemType= itemType,
    this.description= description,
    this.percent= percent
  }
}
